var render = function render(){var _vm=this,_c=_vm._self._c;return _c('guest-detail-edit',{attrs:{"errors":_vm.errors,"showButtons":false,"person":_vm.detail},on:{"save":function($event){return _vm.submit($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }